var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512.002 512.002",
    height: 512,
    viewBox: "0 0 512.002 512.002",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m352.501 264.501c8.271 0 15-6.729 15-15s-6.729-15-15-15-15 6.729-15 15 6.728 15 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.501 264.501c8.271 0 15-6.729 15-15s-6.729-15-15-15-15 6.729-15 15 6.728 15 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m511.909 488.834-37.018-331c-.85-7.592-7.268-13.333-14.907-13.333h-92.483v62.581c17.459 6.192 30 22.865 30 42.419 0 24.813-20.187 45-45 45s-45-20.187-45-45c0-19.555 12.541-36.227 30-42.419v-62.581h-163v62.581c17.459 6.192 30 22.865 30 42.419 0 24.813-20.187 45-45 45s-45-20.187-45-45c0-19.555 12.541-36.227 30-42.419v-62.581h-92.531c-7.64 0-14.06 5.742-14.907 13.335l-36.97 331c-.474 4.242.882 8.484 3.728 11.666s6.911 5 11.18 5h482.002c4.269 0 8.335-1.818 11.181-5s4.2-7.426 3.725-11.668z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.501 118.001c0-44.939 36.561-81.5 81.5-81.5s81.5 36.561 81.5 81.5v26.5h30v-26.5c0-61.481-50.019-111.5-111.5-111.5s-111.5 50.019-111.5 111.5v26.5h30z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping-bag.8a724f62.svg";
export { ForwardRef as ReactComponent };